import OpacityGradient from './OpacityGradient';

export default OpacityGradient;
